import theme_icons from '../../icons.js';
import { AdderGeneric } from '../../components/adder-generic.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';
import GHExhange from "../../../assets/logo/greenheart_exchange_vertical.svg";
import GHExhangeWhite from "../../../assets/logo/GreenheartExchangeLogo_White_V.svg";
import GHTravel from "../../../assets/logo/greenheart_travel_vertical.svg";
import GHTravelWhite from "../../../assets/logo/GreenheartTravelLogo_White_V.svg";
import GH from "../../../assets/logo/greenheart_org_vertical.svg";
import GHWhite from "../../../assets/logo/GreenheartLogo_White_V.svg";



const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { useEffect } = wp.element;
const { RichText, InspectorControls, ColorPalette } = wp.blockEditor;
const { Button, PanelBody, SelectControl, ToggleControl, TextControl } = wp.components;

const imagecards = {
  title: 'Greenheart Image Cards',
  icon: theme_icons.greenheart,
  category: 'greenheart',
  //attributes
  attributes: {
    isAdding: {
      type: 'boolean',
      default: false
    },
    isEditing: {
      type: 'number',
      default: -1
    },
    tagLevel: {
      type: 'string',
      default: 'h3'
    },
    title: {
      type: 'string',
      default: 'Card Title'
    },
    subtitle: {
      type: 'string',
      default: 'Exchange'
    },
    text: {
      type: 'string',
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    },
    branding: {
      type: 'string',
      default: 'none'
    },
    image: {
      type: 'object',
      default: {}
    },
    isLink: {
      type: 'boolean',
      default: false
    },
    isBlank: {
      type: 'boolean',
      default: false
    },
    isSmall: {
      type: 'boolean',
      default: false,
    },
    imageOnly: {
      type: 'boolean',
      default: false
    },
    link: {
      type: 'string',
      default: ''
    },
    linkText: {
      type: 'string',
      default: ''
    },
    textColor: {
      type: 'string',
      default: ''
    },
    accentColor: {
      type: 'string',
      default: ''
    },
    cards: {
      type: 'array',
      default: []
    },
    currentId: {
      type: 'number',
      default: 0
    }

  },

  edit({ attributes, setAttributes }) {
    const { isAdding, isEditing, tagLevel, title, subtitle, text, branding, image, isLink, isBlank, isSmall, link, linkText, textColor, accentColor, cards, imageOnly, currentId } = attributes;

    useEffect(() => {
      let i = getNextId();
      setAttributes({ currentId: i });
    }, []);

    const getNextId = () => {
      let i = 1;
      while (cards.filter((card) => card.id === i).length > 0) { i++; }
      return i;
    }
    function onTextChange(newtext) {
      setAttributes({ text: newtext });
    }
    function onTitleChange(newtitle) {
      setAttributes({ title: newtitle });
    }
    function onSubtitleChange(newsubtitle) {
      setAttributes({ subtitle: newsubtitle });
    }

    function onBrandingChange(newbranding) {
      setAttributes({ branding: newbranding });
    }
    function onImageChange(newimage) {
      setAttributes({ image: newimage });
    }
    function onLinkChange(newlink) {
      setAttributes({ link: newlink });
    }
    function onLinkTextChange(newlinkText) {
      setAttributes({ linkText: newlinkText });
    }
    /* Keep the color settings as they will likely translate to the next card */
    const resetAddCardForm = () => {
      let nextId = getNextId()
      setAttributes({ isAdding: false, isEditing: -1, taglevel: 'h3', title: '', subtitle: '', branding: 'none', text: '', image: {}, link: '', linkText: '' });
    }
    /* Cardsize applies at the list level. You can't put a small card in a large list */
    const cardSize = isSmall ? 240 : 380;
    const cardClass = isSmall ? ' imagecard small' : ' imagecard';

    const addCard = () => {
      const nextId = getNextId(); // Calculate the next ID
      setAttributes({
        currentId: nextId, // Set currentId to the next available ID
        isAdding: true,
        isEditing: -1,
      });
    };

    // const editCard = (id) => {
    //   console.log('Editing card ' + id);
    //   const card = cards.find((card) => card.id === id);
    //   console.log("Card:", card);

    //   // Set the card details for editing, and set the currentId to the card's ID
    //   setAttributes({
    //     title: card.title,
    //     subtitle: card.subtitle,
    //     text: card.text,
    //     textColor: card.textColor,
    //     accentColor: card.accentColor,
    //     branding: card.branding,
    //     image: card.image,
    //     link: card.link,
    //     linkText: card.linkText,
    //     currentId: id, // Set currentId to the card's ID
    //     isEditing: id, // Set the editing mode
    //   });
    // };

    const editCard = (id) => {
      const card = cards.find((card) => card.id === id);

      setAttributes({
        title: card.title,
        subtitle: card.subtitle,
        text: card.text,
        textColor: card.textColor,
        accentColor: card.accentColor,
        branding: card.branding,
        image: card.image,
        link: card.link,
        linkText: card.linkText,
        isBlank: card.isBlank !== undefined ? card.isBlank : false, // Add this line
        currentId: id,
        isEditing: id,
      });
    };

    // const saveCard = () => {
    //   const newCard = {
    //     title: title,
    //     subtitle: subtitle,
    //     tagLevel: tagLevel,
    //     text: text,
    //     textColor: textColor,
    //     accentColor: accentColor,
    //     branding: branding,
    //     image: image,
    //     link: link,
    //     linkText: linkText,
    //     id: currentId, // Use currentId for the card's ID
    //   };

    //   const cardIndex = cards.findIndex((card) => card.id === currentId);
    //   let newCards;

    //   if (cardIndex !== -1) {
    //     // Update the existing card
    //     newCards = [...cards];
    //     newCards[cardIndex] = newCard;
    //   } else {
    //     // Add a new card
    //     newCards = [...cards, newCard];
    //   }

    //   setAttributes({ cards: newCards });
    //   resetAddCardForm();
    // };

    const saveCard = () => {
      const newCard = {
        title: title,
        subtitle: subtitle,
        tagLevel: tagLevel,
        text: text,
        textColor: textColor,
        accentColor: accentColor,
        branding: branding,
        image: image,
        link: link,
        linkText: linkText,
        isBlank: isBlank, // Add this line
        id: currentId,
      };

      const cardIndex = cards.findIndex((card) => card.id === currentId);
      let newCards;

      if (cardIndex !== -1) {
        newCards = [...cards];
        newCards[cardIndex] = newCard;
      } else {
        newCards = [...cards, newCard];
      }

      setAttributes({ cards: newCards });
      resetAddCardForm();
    };

    const deleteCard = (id) => {
      const newCards = cards.filter((card) => card.id !== id);
      setAttributes({ cards: newCards });
    }

    // Move card left (if possible)
    const moveCardLeft = (index) => {
      if (index > 0) {
        const newCards = [...cards];
        const temp = newCards[index];
        newCards[index] = newCards[index - 1];
        newCards[index - 1] = temp;
        setAttributes({ cards: newCards });
      }
    };

    // Move card right (if possible)
    const moveCardRight = (index) => {
      if (index < cards.length - 1) {
        const newCards = [...cards];
        const temp = newCards[index];
        newCards[index] = newCards[index + 1];
        newCards[index + 1] = temp;
        setAttributes({ cards: newCards });
      }
    };

    const displayCards = () => {
      const cardTitle = (title, tagLevel, textColor) => {
        switch (tagLevel) {
          case 'h1': return <h1 style={{ color: textColor }} className="rbt-title">{title}</h1>;
          case 'h2': return <h2 style={{ color: textColor }} className="rbt-title">{title}</h2>;
          case 'h3': return <h3 style={{ color: textColor }} className="rbt-title">{title}</h3>;
          case 'h4': return <h4 style={{ color: textColor }} className="rbt-title">{title}</h4>;
          case 'h5': return <h5 style={{ color: textColor }} className="rbt-title">{title}</h5>;
          case 'h6': return <h6 style={{ color: textColor }} className="rbt-title">{title}</h6>;
          default: return <h3 style={{ color: textColor }} className="rbt-title">{title}</h3>;
        }
      }
      return (
        <div className="cards-wrap">
          {cards.map((card, index) => {
            return (
              <div key={index} className={"rbt-card" + cardClass}>
                <div className="card-image-wrap">
                  <img className="card-image" src={card.image.mediaUrl} srcset={renderSrcSetCard(card, cardSize)} alt={card.title + " image"} />
                  {card.branding.length > 0 && 'none' !== card.branding ? <>
                    <RenderLogo branding={card.branding} />
                  </>
                    :
                    null
                  }
                  {cardTitle(card.title, card.tagLevel, card.textColor)}
                  <h5 className="rbt-subtitle" style={{ color: card.textColor }}>{card.subtitle}</h5>

                </div>
                <div className="card-body">
                  <div className="text-wrap">
                    <p>{card.text}</p>
                  </div>
                  {card.isLink && <a href={card.link} class="card-link">{card.linkText.length > 0 ? card.linkText : ''}</a>}
                </div>
                <div className="card-controls">
                  <Button className="button secondary" onClick={() => deleteCard(card.id)}>Delete</Button>
                  <Button className="button primary" onClick={() => editCard(card.id)}>Edit</Button>
                  <Button className="button move-left" onClick={() => moveCardLeft(index)}>←</Button>
                  <Button className="button move-right" onClick={() => moveCardRight(index)}>→</Button>
                </div>
              </div>
            )
          }
          )}
        </div>
      )
    }
    const renderSrcSetCard = (media, desiredWidth) => {
      const sizes = media.mediaSizes;
      const srcset = [];

      for (const size in sizes) {
        if (sizes.hasOwnProperty(size) && size.includes('square', 'thumbnail')) {
          const width = sizes[size].width;
          if (width >= desiredWidth) {
            srcset.push(`${sizes[size].url} ${width}w`);
          }
        }
      }
      return srcset.join(', ');
    }

    const RenderLogo = ({ branding }) => {
      switch (branding) {
        case 'greenheart_exchange_vertical.svg':
          return <img className="card-branding" src={GHExhange} alt="greenheart exchange branding" />
        case 'GreenheartExchangeLogo_White_V.svg':
          return <img className="card-branding" src={GHExhangeWhite} alt="greenheart exchange branding" />
        case 'greenheart_travel_vertical.svg':
          return <img className="card-branding" src={GHTravel} alt="greenheart travel branding" />
        case 'GreenheartTravelLogo_White_V.svg':
          return <img className="card-branding" src={GHTravelWhite} alt="greenheart travel branding" />
        case 'greenheart_org_vertical.svg':
          return <img className="card-branding" src={GH} alt="greenheart branding" />
        case 'GreenheartLogo_White_V.svg':
          return <img className="card-branding" src={GHWhite} alt="greenheart branding" />
        default:
          return null;
      }
    }

    return ([
      <InspectorControls>
        <PanelBody title="Card Settings">
          <p><strong>Smaller Cards?:</strong></p>
          <ToggleControl
            checked={isSmall}
            onChange={() => { setAttributes({ isSmall: !isSmall }) }}
            help={
              isSmall
                ? 'Smaller Cards'
                : 'Default Size'
            }
          />
          <p><strong>Image Only?:</strong></p>
          <ToggleControl
            checked={imageOnly}
            onChange={() => { setAttributes({ imageOnly: !imageOnly }) }}
            help={
              imageOnly
                ? 'No Text or Buttons under the cards'
                : 'Default Layout'
            }
          />
          {isLink &&
            <>
              <p><strong>Card Link</strong></p>
              <TextControl
                label="Link URL"
                value={link}
                onChange={onLinkChange}
              />
              <p><strong>Link Text (leave blank to link the entire card)</strong></p>
              <TextControl
                label="Link Text"
                value={linkText}
                onChange={onLinkTextChange}
              />


              <p><strong>Open in New Tab?</strong></p>
              <ToggleControl
                label="Open link in a new tab"
                checked={isBlank}
                onChange={(newValue) => setAttributes({ isBlank: newValue })}
              />


            </>
          }

          <p><strong>Tag Level:</strong></p>
          <SelectControl
            label="Tag Level"
            value={tagLevel}
            options={[
              { label: 'H1', value: 'h1' },
              { label: 'H2', value: 'h2' },
              { label: 'H3', value: 'h3' },
              { label: 'H4', value: 'h4' },
              { label: 'H5', value: 'h5' },
              { label: 'H6', value: 'h6' }
            ]}
            onChange={(newTagLevel) => setAttributes({ tagLevel: newTagLevel })}
          />
          <p><strong>Accent Color:</strong></p>
          <ColorPalette
            value={accentColor}
            onChange={(color) => setAttributes({ accentColor: color })}
          />
          <p><strong>Text Color:</strong></p>
          <ColorPalette
            value={textColor}
            onChange={(color) => setAttributes({ textColor: color })}
          />
        </PanelBody>
      </InspectorControls>,
      <div className="rbt-imagecards">
        {(isAdding || isEditing > 0) ?
          <div className="rbt-imagecards-form icon">
            <div className="card-wrap">
              <div className="image-area">
                <MediaUploaderGeneric photo={image} updateImage={onImageChange} />
              </div>
              <div class="branding-area">
                {branding.length > 0 && 'none' !== branding ? <>
                  <RenderLogo branding={branding} />
                  <Button className="button secondary" onClick={() => onBrandingChange('none')}>Remove Branding</Button>
                </>
                  :
                  <SelectControl
                    label="Branding"
                    value={branding}
                    options={[
                      { label: 'None', value: 'none' },
                      { label: 'Greenheart Exchange', value: 'greenheart_exchange_vertical.svg' },
                      { label: 'Greenheart Exchange White', value: 'GreenheartExchangeLogo_White_V.svg' },
                      { label: 'Greenheart Travel', value: 'greenheart_travel_vertical.svg' },
                      { label: 'Greenheart Travel White', value: 'GreenheartTravelLogo_White_V.svg' },
                      { label: 'Greenheart', value: 'greenheart_org_vertical.svg' },
                      { label: 'Greenheart White', value: 'GreenheartLogo_White_V.svg' },

                    ]}
                    onChange={onBrandingChange}
                  />
                }
              </div>
              <div className="title-area">
                <RichText
                  tagName={tagLevel}
                  className="card-title"
                  value={title}
                  onChange={onTitleChange}
                  placeholder="Card Title"
                  style={{ color: textColor }}
                />
              </div>
              <div className="subtitle-area">
                <RichText
                  tagName="h5"
                  className="card-subtitle"
                  value={subtitle}
                  onChange={onSubtitleChange}
                  placeholder="Host"
                  style={{ color: textColor }}
                />
              </div>
              {!imageOnly ? <div className="text-area">
                <RichText
                  tagName="p"
                  value={text}
                  onChange={onTextChange}
                  placeholder="Card Text"
                />
              </div> : null}

              <div className="link-area">
                <p><strong>Link the Card? (see right column for link)</strong></p>
                <ToggleControl
                  checked={isLink}
                  onChange={() => { setAttributes({ isLink: !isLink }) }}
                />

              </div>
            </div>
            {title.length > 0 && image.hasOwnProperty('mediaUrl') && image.mediaUrl.length > 0 && <Button className="button primary" onClick={saveCard}>Save Card</Button>}
            <Button className="button secondary" onClick={resetAddCardForm}>Cancel</Button>
          </div>
          :
          <div className="rbt-imagecards-cards">
            {displayCards()}
            <AdderGeneric onAdd={addCard} />
          </div>
        }
      </div>
    ]);
  },
  save({ attributes }) {
    const { cards, isSmall, imageOnly } = attributes;
    const cardSize = isSmall ? 240 : 380;
    const cardClass = isSmall ? ' imagecard small' : ' imagecard';
    const finalCardClass = imageOnly ? cardClass + ' square' : cardClass;

    const renderSrcSetCard = (media, desiredWidth) => {
      const sizes = media.mediaSizes;
      const srcset = [];

      for (const size in sizes) {
        if (sizes.hasOwnProperty(size) && size.includes('square')) {
          const width = sizes[size].width;
          if (width >= desiredWidth) {
            srcset.push(`${sizes[size].url} ${width}w`);
          }
        }
      }
      return srcset.join(', ');
    }

    const cardTitle = (title, tagLevel, textColor) => {
      switch (tagLevel) {
        case 'h1': return <h1 style={{ color: textColor }} className="rbt-title">{title}</h1>;
        case 'h2': return <h2 style={{ color: textColor }} className="rbt-title">{title}</h2>;
        case 'h3': return <h3 style={{ color: textColor }} className="rbt-title">{title}</h3>;
        case 'h4': return <h4 style={{ color: textColor }} className="rbt-title">{title}</h4>;
        case 'h5': return <h5 style={{ color: textColor }} className="rbt-title">{title}</h5>;
        case 'h6': return <h6 style={{ color: textColor }} className="rbt-title">{title}</h6>;
        default: return <h3 style={{ color: textColor }} className="rbt-title">{title}</h3>;
      }
    }
    const RenderLogo = ({ branding }) => {
      switch (branding) {
        case 'greenheart_exchange_vertical.svg':
          return <img className="card-branding" src={GHExhange} alt="greenheart exchange branding" />
        case 'GreenheartExchangeLogo_White_V.svg':
          return <img className="card-branding" src={GHExhangeWhite} alt="greenheart exchange branding" />
        case 'greenheart_travel_vertical.svg':
          return <img className="card-branding" src={GHTravel} alt="greenheart travel branding" />
        case 'GreenheartTravelLogo_White_V.svg':
          return <img className="card-branding" src={GHTravelWhite} alt="greenheart travel branding" />
        case 'greenheart_org_vertical.svg':
          return <img className="card-branding" src={GH} alt="greenheart branding" />
        case 'GreenheartLogo_White_V.svg':
          return <img className="card-branding" src={GHWhite} alt="greenheart branding" />
        default:
          return null;
      }
    }
    console.log("Cards", cards);
    return (
      <div className="rbt-imagecards" data-process="uniform-rows">
        {cards.map((card, index) => {
          const shouldWrapWithLink = card.link.length > 0 && card.linkText.length === 0;
          const cardContent = (
            <div className="card-image-area">
              <img className="card-image" src={card.image.mediaUrl} srcSet={renderSrcSetCard(card, cardSize)} loading="lazy" alt={`${card.title} image`} />
              {card.branding.length > 0 && card.branding !== 'none' && <RenderLogo branding={card.branding} />}
              {cardTitle(card.title, card.tagLevel, card.textColor)}
              <h5 className="rbt-subtitle" style={{ color: card.textColor }}>{card.subtitle}</h5>
            </div>
          );
          return (
            <div key={index} className={"rbt-card" + finalCardClass}>
              <div className="card-image-wrap">
                {shouldWrapWithLink ? (
                  <a href={card.link}
                    target={(card.hasOwnProperty("isBlank") && card.isBlank) ? "_blank" : "_self"}
                    rel="noopener"
                    style="text-decoration:none;"
                  >
                    {cardContent}
                  </a>
                ) : (
                  cardContent
                )}
              </div>

              <div className="card-body">
                {!imageOnly ? <div className="textarea">
                  <p>{card.text}</p>
                </div> : null}

                {card.link.length > 0 && card.linkText.length > 0 && !imageOnly &&
                  <div className="wp-block-button">
                    <a
                      href={card.link}
                      target={(card.hasOwnProperty("isBlank") && card.isBlank) ? "_blank" : "_self"}
                      rel="noopener"
                      className="wp-block-button__link wp-element-button"
                    >{card.linkText}</a>
                  </div>
                }
              </div>
            </div>
          )
        })}
      </div>
    )
  }
};
registerBlockType('rbt/imagecards', imagecards);
export default imagecards;
